import { render, staticRenderFns } from "./Work.vue?vue&type=template&id=09eff3bc"
import script from "./Work.vue?vue&type=script&lang=ts"
export * from "./Work.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports